import { ContainerField as ContainerFieldType } from "../types";

export const ContainerField: React.FC<ContainerFieldType> = ({ Component = "div", ...props }) => (
  <Component {...props} />
);
